import { createAction } from '@reduxjs/toolkit';

export const setCommonsFailed = createAction<boolean>(
  'common/setCommonsFailed'
);
